import { render } from "./FAQItem.vue?vue&type=template&id=52911340&scoped=true&ts=true"
import script from "./FAQItem.vue?vue&type=script&lang=ts"
export * from "./FAQItem.vue?vue&type=script&lang=ts"

import "./FAQItem.vue?vue&type=style&index=0&id=52911340&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52911340"]])

export default __exports__